import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [tries, setTries] = useState(0);
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        setStatus(data.payment_status);
        if (data.payment_status === "paid") {
          refresh();
          return;
        }
      } catch (_e) {}
      if (!cancelled && tries < 20) {
        setTimeout(() => setTries((t) => t + 1), 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, tries, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-success">
      <div className="max-w-lg text-center">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-[hsl(var(--secondary))] mx-auto mb-8" strokeWidth={1.25} />
            <div className="label-eyebrow mb-4">Welcome home</div>
            <h1 className="font-serif text-5xl md:text-6xl leading-[1.05] mb-6">
              You're <em className="italic text-[hsl(var(--primary))]">in</em>.
            </h1>
            <p className="text-stone-600 leading-relaxed mb-10">
              Your membership is active. Everything unlocks now — quietly, at your pace.
            </p>
            <Link to="/app" data-testid="btn-start-practice" className="inline-flex items-center gap-2 bg-[hsl(var(--primary))] text-white px-8 py-4 hover:bg-[hsl(var(--foreground))] transition-colors">
              Begin the practice
            </Link>
          </>
        ) : (
          <>
            <Loader2 className="w-12 h-12 text-stone-400 mx-auto mb-8 animate-spin" strokeWidth={1.5} />
            <h1 className="font-serif text-4xl leading-tight mb-4">Confirming your payment…</h1>
            <p className="text-stone-500">This usually takes a few seconds.</p>
          </>
        )}
      </div>
    </div>
  );
}
